import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import SaleInvoiceServices from "../../services/SaleInvoice";
import { ErrorToaster, SuccessToaster } from "../components/toaster/Toaster";
import Form from "./components/form";

const EditSale = () => {

  const route = all_routes;
  const navigate = useNavigate();
  const { id } = useParams();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const updateSaleInvoice = async (payload) => {
    setLoading(true)
    try {
      await SaleInvoiceServices.updateSaleInvoice(id, payload)
      SuccessToaster('Update Successfully')
      navigate(route?.sales)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Edit Sale</h4>
              <h6>Edit sale invoice</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={updateSaleInvoice} loading={loading} />
      </div>
    </div>
  );
};

export default EditSale;
